/**
 * Session-scoped cache to deduplicate PostHog groupIdentify calls.
 *
 * Prevents redundant network requests when the same brand/model is
 * resolved multiple times within a session.
 */
const identified = new Set<string>();

const toKey = (groupType: string, groupKey: string): string => `${groupType}:${groupKey}`;

export const groupIdentifyCache = {
  has: (groupType: string, groupKey: string): boolean => identified.has(toKey(groupType, groupKey)),

  add: (groupType: string, groupKey: string): void => {
    identified.add(toKey(groupType, groupKey));
  },

  clear: (): void => {
    identified.clear();
  }
};
